export const theme = ({ fonts, colors, position }) => {
  return {
    colors: {
      primary: colors.primary || "#006cff",
      secondary: colors.secondary || "rgb(52 124 255 / 12%)",
      white: "#fff",
      black: "#000",
      font: "#383c46",
      fontDark: "#121212",
      gray: "#d9dadc",
      error: "#fc576b",
      success: "#34ca77",
    },
    font: {
      primary: fonts[0],
      secondary: fonts[1] || fonts[0],
    },
    f_sizes: {
      xs: 8,
      base: 13,
      l: 15,
      xl: 18,
    }
  };
};
